<template functional>
  <span class="text-secondary">[<span class="font-italic">Deleted</span>]</span>
</template>

<script>
export default {
  name: 'DeletedEntity'
}
</script>

<style lang="scss" scoped></style>
